import React from "react";
import axios from "axios";
import "./FilesList.css";
import cptIcon from "../cpt.svg";
import prvIcon from "../prv.svg";
import totIcon from "../tot.svg";
import Checkbox from "@material-ui/core/Checkbox";
import download from "downloadjs";
import _ from "lodash";
import { updateSoilprofile } from "../api/PostBorehole";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { REACT_APP_GEOTOLK_API, TOKEN_GEOTOLK } from "../Config/Common";


// import {postBorehole} from '../api/PostBorehole';
export function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default class FilesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilesList: true,
      theSelectedFile: "",
      checkedFiles: this.props.checkedFiles,
      allChecked: this.props.allChecked,
      boreholeList: this.props.boreholeList,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
    };
    // this.toggleFilesList = this.toggleFilesList.bind(this);
    this.selectFile = this.selectFile.bind(this);
    this.handleCheck = this.props.handleCheck.bind(this);
  }

  updateAnalysis = () => {
    let activeIndexes = this.props.checkedFiles;

    this.props.updateAnalysis(activeIndexes);
    let elem = document.getElementById("analysis");
    if (elem != null) {
      elem.scrollIntoView({ behavior: "smooth" });
    }
  };

  // componentDidUpdate(prevProps) {
  //   if (prevProps.checkedFiles !== this.props.checkedFiles) {
  //     this.setState({ checkedFiles: this.props.checkedFiles });
  //   }
  // }

  handleSaveState = () => {
    if (!this.props.checkedFiles) {
      this.setState({
        snackbarMessage: "Ingen filer er valgt",
        snackbarSeverity: "warning",
        snackbarOpen: true,
      });
      return;
    }
    console.log('this.props.boreholeList', this.props.boreholeList)
    const filesToSave = this.props.checkedFiles.map((fileID) => {
      return this.props.boreholeList[fileID];
    }).filter(Boolean);
    
    const token = this.props.token;
    filesToSave.forEach(async (borehole) => {
      const location_id = borehole.id;
      const tlk = borehole.DYNAMIC_DATA.slice(0, -1);

      try {
        const response = await updateSoilprofile(this.props.project_id, location_id, tlk, token);
        this.setState({
          snackbarMessage: `Success ${this.props.checkedFiles.length} files saved`,
          snackbarSeverity: "success",
          snackbarOpen: true,
        });
      } catch (error) {
        this.setState({
          snackbarMessage: `Error with ${borehole.BORHOLE_NAME}. Please refresh the page manually and try again. Error: ${error.message}`,
          snackbarSeverity: "error",
          snackbarOpen: true,
        });
      }

    }


    );
  };
  handleCSVDownload = () => {
    if (this.props.checkedFiles.length > 0) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
          "Content-Type": "application/json",
        },
        params: {
          max_layers: 2,
          min_depth_layer: 1,
          classify_bedrock: true,
          plot_proba: true,
          smoothing_depth_layers: 5,
          convertLayersStandard: true,
          from_geotolk: true,
          writeWhere: this.props.writeWhere,
        },
      };

      this.props.onLoadingChange(true);

      this.props.checkedFiles.forEach((boreholeID) => {
        const currentBorehole = this.props.boreholeList[boreholeID];
        console.log('currentBorehole', currentBorehole);
        console.log('currentBorehole["TLK"]', currentBorehole["TLK"]);

        // Ensure tlk_params is an array
        const exportData = Array.isArray(currentBorehole["TLK"]) ? currentBorehole["TLK"] : [currentBorehole["TLK"]];
        console.log('exportData', exportData);

        axios
          .post(
            `${REACT_APP_GEOTOLK_API}/export/csv`,      // Correct endpoint
            exportData,           // JSON array as request body
            config                // Headers and query parameters
          )
          .then((res) => {
            const { LOCATION_CSV: locationCSV, INTERPRETATION_CSV: interpretCSV } = res.data;

            // Trigger downloads
            download(locationCSV, "CSV_1.csv", "text/csv");
            download(interpretCSV, "CSV_2.csv", "text/csv");
          })
          .catch((error) => {
            console.error("Klarte ikke eksportere CSV:", error.response ? error.response.data : error.message);
            alert("Klarte ikke eksportere CSV. Vennligst prøv igjen.");
          })
          .finally(() => {
            this.props.onLoadingChange(false);
          });
      });
    } else {
      alert("Trenger minst en fil");
    }
  };

  handleTLKDownload = () => {
    if (this.props.checkedFiles.length > 0) {
      const JSZip = require("jszip");
      const zip = new JSZip();
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.token}`,
          "Content-Type": "application/json",
        },
        params: {
          max_layers: 2,
          min_depth_layer: 1,
          classify_bedrock: true,
          plot_proba: true,
          smoothing_depth_layers: 5,
          convertLayersStandard: true,
          from_geotolk: true,
          writeWhere: this.props.writeWhere,
        },
      };
      this.props.onLoadingChange(true);
      this.successfulFiles = 0;
      this.failedFiles = 0;

      this.props.checkedFiles.forEach((boreholeID) => {
        const currentBorehole = this.props.boreholeList[boreholeID];
        console.log('currentBorehole', currentBorehole)
        console.log('currentBorehole["TLK"]', currentBorehole["TLK"])

        // Ensure tlk_params is an array
        const tlkParams = Array.isArray(currentBorehole["TLK"]) ? currentBorehole["TLK"] : [currentBorehole["TLK"]];

        axios
          .post(
            `${REACT_APP_GEOTOLK_API}/export/tlk`,
            tlkParams,             // Send tlk_params as the request body
            config                  // config contains headers and params
          )
          .then((res) => {
            const { NAME: filename, DATA: tlk } = res.data.TLK_TEXT;
            zip.file(filename, tlk);
            this.successfulFiles += 1;
          })
          .catch((error) => {
            console.error("TLK download error:", error);
            this.failedFiles += 1;
          })
          .finally(() => {
            if (
              this.successfulFiles + this.failedFiles ===
              this.props.checkedFiles.length
            ) {
              zip.generateAsync({ type: "blob" }).then((content) => {
                download(content, "TLK_FILES.zip");
              });
            }
            this.props.onLoadingChange(false);
          });
      });
    } else {
      alert("Trenger minst en fil");
    }
  };

  scrollToMapView = () => {
    let element = document.getElementById("map");
    if (element != null) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  selectFile = (selectedFile) => {
    this.setState({ theSelectedFile: selectedFile });

    this.props.updateDetailedView(selectedFile);
    let elem = document.getElementById("detailedView");
    if (elem != null) {
      elem.scrollIntoView({ behavior: "smooth" });
    }
  };
  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  //   toggleFilesList() {
  //     this.setState((prevState) => ({
  //       showFilesList: !prevState.showFilesList,
  //     }));
  //     this.props.handleListToggle(this.state.showFilesList);
  //   }

  render() {
    let files;
    let text;
    // let toggle;
    let checkAll;
    let deleteFiles;
    if (this.props.boreholeList) {
      text = <span />;
      deleteFiles = (
        <button className="deleteButton" onClick={this.props.handleDelete}>
          Slett filer
        </button>
      );
      checkAll = (
        <span className="checkbox-checkAll-container">
          <Checkbox
            className="checkbox-checkAll"
            name="checkAll"
            color="primary"
            inputProps={{ "aria-label": "uncontrolled-checkbox" }}
            labelplacement="end"
            label="Check all"
            onChange={(e) => this.props.handleCheckAll(e)}
          />
        </span>
      );
      files = Object.entries(this.props.boreholeList).map(([key, borhole]) => (
        <div className="file" key={"file-" + key}>
          <Checkbox
            className="checkbox"
            color="primary"
            inputProps={{ "aria-label": "uncontrolled-checkbox" }}
            label={key}
            key={key}
            onChange={(e) => this.handleCheck(e, key)}
            checked={this.props.checkedFiles.includes(key)}
          />
          <div
            className="fileInfo"
            onClick={() => this.selectFile(key)}
            key={"fileInfo" + key}
          >
            <div
              className="fileName"
              style={
                key === this.state.theSelectedFile
                  ? { fontWeight: "bold" }
                  : { fontWeight: "normal" }
              }
            >
              {borhole.BORHOLE_NAME}
            </div>
            <img
              src={totIcon}
              alt={"totalsondering ikon"}
              className="totIcon"
            />
            <img
              src={cptIcon}
              alt={"cpt ikon"}
              className="cptIcon"
              style={borhole.CPT ? { width: 15 } : { width: 0 }}
            />
            <img
              src={prvIcon}
              alt={"prv ikon"}
              className="prvIcon"
              style={borhole.PRV ? { width: 15 } : { width: 0 }}
            />
          </div>
        </div>
      ));
    } else {
      files = <span />;
      text = <p className="noFiles">Ingen filer er opplastet</p>;
    }

    if (this.state.showFilesList === true) {
      //   toggle = <span>&#9664;</span>;
    } else {
      //   toggle = <span>&#9654;</span>;
    }

    return (
      <div
        className="filesList"
      // style={
      //   this.state.showFilesList ? { marginLeft: 0 } : { marginLeft: -260 }
      // }
      >
        {/* <span className="closeFiles" onClick={this.toggleFilesList}>
          {toggle}
        </span> */}
        <span className="showButtonsContainer">
          <button
            className="tolkningsplottButton"
            onClick={this.updateAnalysis}
          >
            Vis Tolkningsplott
          </button>
          <button className="mapButton" onClick={this.scrollToMapView}>
            Gå til kartvisning
          </button>
        </span>
        <span style={{ marginBottom: "200px" }}>
          <Snackbar
            open={this.state.snackbarOpen}
            autoHideDuration={3000}
            onClose={this.handleSnackbarClose}
            anchorOrigin={{ vertical: "top", horizontal: "middle" }}
          >
            <Alert
              onClose={this.handleSnackbarClose}
              severity={this.state.snackbarSeverity}
            >
              {this.state.snackbarMessage}
            </Alert>
          </Snackbar>
        </span>
        <span className="downloadButtonsContainer">
          <button className="csvButton" onClick={this.handleCSVDownload}>
            Last ned CSV-filer
          </button>
          <button className="tlkButton" onClick={this.handleTLKDownload}>
            Last ned TLK-filer
          </button>
          <button className="saveButton" onClick={this.handleSaveState}>
            Save to database
          </button>
        </span>
        <div className="markAndDelete">
          {checkAll}
          <span className="numberOfFiles">
            {this.props.checkedFiles.length} markert av{" "}
            {Object.keys(this.props.boreholeList).length}
          </span>
          <span className="deleteButton-container">{deleteFiles}</span>
        </div>
        <div className="files">
          {files}
          {text}
        </div>
      </div>
    );
  }
}
